export default {
      id: "panel-menu-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#panel-menu",
      toString: function () {
        return this.url;
      }
    }